// src/lib/layouts/clampClipRatio.ts
export const CLIP_RATIO_MIN = 10;
export const CLIP_RATIO_MAX = 90;
export const CLIP_RATIO_DEFAULT = 50;

/** Clamp a satisfatorio clipRatio into [CLIP_RATIO_MIN, CLIP_RATIO_MAX]; junk falls back to the default. */
export function clampClipRatio(value: unknown): number {
  const n = Number(value);
  if (!Number.isFinite(n)) return CLIP_RATIO_DEFAULT;
  return Math.min(CLIP_RATIO_MAX, Math.max(CLIP_RATIO_MIN, n));
}
